import React from 'react';

export function Sidebar({ brand, tenant, groups, activeKey, onSelect, user, collapsed = false }) {
  const c = collapsed;
  return (
    <aside style={{
      width: c ? '72px' : '248px', flex: 'none', background: 'var(--surface-1)', borderRight: '1px solid var(--border)',
      display: 'flex', flexDirection: 'column', alignItems: c ? 'center' : 'stretch', gap: '20px', padding: c ? '20px 10px' : '20px 14px', height: '100%', fontFamily: 'var(--font-body)',
      transition: 'width var(--duration-base) var(--ease-standard)',
    }}>
      {brand}
      {tenant && (
        <div title={c ? tenant.name : undefined} style={{ display: 'flex', gap: '10px', alignItems: 'center', padding: c ? '6px' : '10px', border: '1px solid var(--border)', borderRadius: 'var(--radius-md)', background: 'var(--surface-2)' }}>
          {tenant.crest
            ? <img src={tenant.crest} alt="" style={{ width: 30, height: 30, objectFit: 'contain', flex: 'none' }} />
            : <div style={{ width: 30, height: 30, borderRadius: '50%', background: tenant.accentColor || 'var(--brand-primary)', color: '#fff', display: 'grid', placeItems: 'center', fontSize: 10, fontWeight: 700, flex: 'none' }}>{tenant.initials}</div>}
          {!c && (
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 600, fontSize: 'var(--fs-body-sm)', color: 'var(--text-1)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{tenant.name}</div>
              <div style={{ fontSize: 'var(--fs-caption)', color: 'var(--text-muted)' }}>{tenant.subtitle || 'School · switch'}</div>
            </div>
          )}
        </div>
      )}
      <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: c ? '10px' : '18px', width: '100%' }}>
        {groups.map((g, gi) => (
          <div key={g.label} style={c && gi ? { borderTop: '1px solid var(--border)', paddingTop: 10 } : undefined}>
            {!c && <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: 'var(--ls-caps)', textTransform: 'uppercase', color: 'var(--text-muted)', padding: '0 10px', marginBottom: '6px' }}>{g.label}</div>}
            <nav style={{ display: 'flex', flexDirection: 'column', alignItems: c ? 'center' : 'stretch', gap: '2px' }}>
              {g.items.map((item) => {
                const active = item.key === activeKey;
                return (
                  <a key={item.key} title={c ? item.label : undefined} onClick={() => onSelect && onSelect(item.key)} style={{
                    display: 'flex', alignItems: 'center', justifyContent: c ? 'center' : 'flex-start', gap: '10px', padding: c ? 0 : '0 10px', height: c ? '44px' : '36px', width: c ? '44px' : 'auto',
                    borderRadius: 'var(--radius-pill)', fontSize: 'var(--fs-body-md)', cursor: 'pointer',
                    color: active ? 'var(--text-on-primary)' : 'var(--text-2)',
                    background: active ? 'var(--brand-primary)' : 'transparent',
                    fontWeight: active ? 600 : 500,
                  }}>
                    {item.icon}
                    {!c && <span style={{ flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.label}</span>}
                    {!c && item.badge}
                  </a>
                );
              })}
            </nav>
          </div>
        ))}
      </div>
      {user && (
        <div title={c ? user.name : undefined} style={{ display: 'flex', alignItems: 'center', justifyContent: c ? 'center' : 'flex-start', gap: '10px', paddingTop: '14px', borderTop: '1px solid var(--border)', width: '100%' }}>
          <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'var(--brand-primary-soft)', color: 'var(--brand-primary-ink)', display: 'grid', placeItems: 'center', fontWeight: 600, fontSize: 12, flex: 'none' }}>{user.initials}</div>
          {!c && (
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 500, fontSize: 'var(--fs-body-sm)', color: 'var(--text-1)' }}>{user.name}</div>
              <div style={{ fontSize: 'var(--fs-caption)', color: 'var(--text-muted)' }}>{user.role}</div>
            </div>
          )}
        </div>
      )}
    </aside>
  );
}
